(function () {
	'use strict';
	$(() => {
		const ratingStars = document.querySelectorAll('.rating-star');

		ratingStars?.forEach((star) => {
			star.addEventListener('click', function () {
				const rating = this.value;
				ratingStars?.forEach((star, index) => {
					star.classList.toggle('active', index < rating);
				});
			});
		});
	});
})();
